import { EntityActionNames, IEntityAction } from '~src/app/spaces/ActionsMenu/EntityActions/IEntityAction';
import { AppState } from '~src/app/state/AppState';
import { Messages } from '~src/codegen/Localize';
import { updateDataFreshnessPolicy } from '~src/dataAcceleration/actions/UpdateDataFreshnessPolicyAction';
import { FeatureFlags } from '~src/ts/FeatureFlags';
import { WorkbookContentType } from '~src/ts/models/ContentTypes';
import { IContentInfo } from '~src/ts/models/IContentInfo';
import { IEditDataFreshnessPolicyAction } from '~src/ts/ServerApi/types/actionNames';

export const UpdateDataFreshnessPolicyEntityAction: IEntityAction<IContentInfo, IEditDataFreshnessPolicyAction> = {
  name: EntityActionNames.UpdateDataFreshnessPolicy,
  translateName: Messages.editDataFreshnessPolicyButtonText,
  isVisible: (targetItems: IContentInfo[], state: AppState, availableAction: IEditDataFreshnessPolicyAction) => {
    return FeatureFlags.queryPipelineDataFreshnessUISupported &&
      targetItems && targetItems.length === 1 &&
      targetItems[0].contentType === WorkbookContentType.name &&
      availableAction && availableAction.editDataFreshnessPolicy;
  },
  isClickable: () => true,
  createReduxAction: (targetItems: IContentInfo[]) => {
    return updateDataFreshnessPolicy(targetItems);
  }
};
